/* Additive campaign UI. Native Shopify variants, cart and checkout remain authoritative. */
(() => {
  'use strict';
  const boot = () => {
    const root = document.querySelector('[data-sf-root]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];
    const locale = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const endpoint = path => locale + path;
    const registry = { 'pawturn-treat-bowl': { view: 'enova-pawturn' } };
    const handle = root.dataset.handle;
    if (!registry[handle]) return;
    const storageKey = 'enova-campaign:' + handle;
    const form = $('#sf-product-form');
    const variants = JSON.parse($('[data-sf-variants]')?.textContent || '[]');
    const money = cents => new Intl.NumberFormat('en-US', { style:'currency', currency:root.dataset.currency || 'USD' }).format(cents / 100);
    const purchasable = root.dataset.purchasable === 'true';
    let selected = null, busy = false, uncertain = false, latestCart = null;
    const tell = (node, text) => { if (node) { node.textContent = text; node.hidden = !text; } };
    const fetchJSON = async (path, options = {}) => {
      const response = await fetch(endpoint(path), { credentials:'same-origin', ...options, signal:AbortSignal.timeout(18000) });
      if (!/^(application\/json|text\/javascript|application\/javascript)(;|$)/i.test(response.headers.get('content-type') || '')) throw new Error('Shopify could not load your bag. Please refresh before trying again.');
      const data = await response.json();
      if (!response.ok) { const error = new Error(data.description || data.message || 'Shopify could not update your bag.'); error.status = response.status; throw error; }
      return data;
    };
    const safeReturn = value => {
      try {
        const url = new URL(value, location.origin);
        const expected = endpoint('/products/' + handle);
        if (url.origin !== location.origin || ![expected, endpoint('/products_preview')].includes(url.pathname)) return null;
        if (url.searchParams.get('view') !== registry[handle].view) return null;
        if (url.pathname.endsWith('products_preview') && !/^[a-f0-9]{32}$/i.test(url.searchParams.get('preview_key') || '')) return null;
        return url;
      } catch { return null; }
    };
    const remember = () => {
      if (!form) return;
      const url = new URL(location.href); url.searchParams.set('view', registry[handle].view);
      if (selected) url.searchParams.set('variant', String(selected.id));
      if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
      url.hash = '';
      try { sessionStorage.setItem(storageKey, url.href); } catch { /* Storage is optional. */ }
    };
    const cartURL = new URL(endpoint('/cart'), location.origin);
    cartURL.searchParams.set('view', 'enova-pawturn'); cartURL.searchParams.set('campaign', handle);
    if (window.Shopify?.theme?.role === 'unpublished') cartURL.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
    $$('[data-full-cart]').forEach(a => a.href = cartURL.href);
    if (form) form.querySelector('[name="return_to"]').value = cartURL.pathname + cartURL.search;
    try {
      const remembered = safeReturn(sessionStorage.getItem(storageKey));
      if (remembered) $$('[data-return-pdp]').forEach(a => a.href = remembered.href);
    } catch { /* Use the verified server-rendered fallback. */ }
    const setBusy = value => {
      busy = value;
      $$('[data-add-button]').forEach(b => b.disabled = value || uncertain || !purchasable || !selected?.available);
      $$('[data-cart-quantity], [data-cart-remove], [data-checkout]').forEach(b => b.disabled = value || uncertain || (b.hasAttribute('data-checkout') && !latestCart?.item_count));
      root.setAttribute('aria-busy', String(value));
    };
    const showImage = button => {
      if (!button) return;
      const image = $('[data-hero-image]');
      image.src = button.dataset.image; image.alt = button.dataset.alt;
      tell($('[data-gallery-caption]'), button.dataset.caption);
      tell($('[data-gallery-index]'), button.dataset.index + ' / ' + ($('[data-gallery-count]')?.dataset.galleryCount || $$('[data-gallery-role]').length));
      $$('[data-gallery-role]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    };
    const paint = (updateURL = true) => {
      if (!form) return;
      selected = variants.find(v => String(v.id) === form.querySelector('[name="id"]:checked')?.value);
      if (!selected) { setBusy(false); return; }
      $$('[data-selected-name]').forEach(n => n.textContent = selected.title);
      $$('[data-selected-price], [data-button-price]').forEach(n => n.textContent = money(selected.price));
      tell($('[data-add-label]'), selected.available || !purchasable ? 'Add to bag' : 'Unavailable');
      showImage($('[data-gallery-role="play"]'));
      if (updateURL) { const url = new URL(location.href); url.searchParams.set('variant', selected.id); history.replaceState(null, '', url); }
      remember(); setBusy(busy);
    };
    $$('[data-gallery-role]').forEach(b => b.addEventListener('click', () => showImage(b)));
    $$('[data-select-offer]').forEach(b => b.addEventListener('click', () => {
      const radio = $('[data-offer-role="' + b.dataset.selectOffer + '"]');
      if (radio) { radio.checked = true; paint(); $('#sf-choose').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }); radio.focus({ preventScroll:true }); }
    }));
    if (form) { form.addEventListener('change', () => paint()); paint(false); }
    // Native dialog provides keyboard focus trapping and Escape behavior.
    const openDialog = dialog => { if (!dialog.open) dialog.showModal(); document.body.classList.add('sf-modal-open'); };
    $$('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => { if (!document.querySelector('dialog[open]')) document.body.classList.remove('sf-modal-open'); });
      dialog.querySelectorAll('[data-close-dialog]').forEach(b => b.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
    });
    $$('[data-policy]').forEach(b => b.addEventListener('click', () => { const d = $('#sf-policy-' + b.dataset.policy); if (d) openDialog(d); }));
    // Policy documents remain intact; their storefront-home links are plain text here.
    $$('.sf-policy-content a').forEach(a => {
      try { const u = new URL(a.href); if (u.origin === location.origin && !u.pathname.startsWith('/policies/')) a.replaceWith(document.createTextNode(a.textContent)); } catch { /* Keep legal contact links. */ }
    });
    const el = (tag, className, text) => { const n = document.createElement(tag); if (className) n.className = className; if (text !== undefined) n.textContent = text; return n; };
    const renderCart = cart => {
      latestCart = cart;
      $$('[data-cart-count]').forEach(n => n.textContent = String(cart.item_count));
      $$('[data-cart-total]').forEach(n => n.textContent = money(cart.total_price));
      const list = $('[data-cart-items]');
      if (!list) return;
      list.replaceChildren();
      if (!cart.item_count) list.append(el('p', 'sf-cart-empty', 'Your bag is empty. Meet Pawturn to get treat time rolling.'));
      cart.items.forEach(item => {
        const row = el('article', 'sf-cart-item'); row.dataset.key = item.key;
        if (item.image) { const img = el('img'); img.src = item.image; img.alt = item.product_title; img.width = 88; img.height = 88; row.append(img); }
        const copy = el('div', 'sf-cart-item-copy'); copy.append(el('h3', '', item.product_title));
        if (item.variant_title && item.variant_title !== 'Default Title') copy.append(el('p', '', item.variant_title));
        if (item.selling_plan_allocation?.selling_plan?.name) copy.append(el('p', '', item.selling_plan_allocation.selling_plan.name));
        Object.entries(item.properties || {}).filter(([k,v]) => !k.startsWith('_') && v).forEach(([k,v]) => copy.append(el('p', '', k + ': ' + v)));
        copy.append(el('strong', '', money(item.final_line_price)));
        (item.line_level_discount_allocations || []).forEach(d => copy.append(el('small', '', d.discount_application.title + ': −' + money(d.amount))));
        const quantity = el('div', 'sf-cart-qty');
        [[-1,'−'], [1,'+']].forEach(([delta, label], index) => {
          const b = el('button', '', label); b.type = 'button'; b.dataset.cartQuantity = String(delta); b.dataset.key = item.key;
          b.setAttribute('aria-label', (delta < 0 ? 'Decrease ' : 'Increase ') + item.product_title + ' quantity');
          if (index) quantity.append(el('output', '', String(item.quantity)));
          quantity.append(b);
        });
        const remove = el('button', 'sf-remove', 'Remove'); remove.type = 'button'; remove.dataset.cartRemove = item.key; remove.setAttribute('aria-label', 'Remove ' + item.product_title);
        copy.append(quantity, remove); row.append(copy); list.append(row);
      });
      $$('[data-cart-discounts]').forEach(n => { n.textContent = (cart.cart_level_discount_applications || []).map(d => d.title + ': −' + money(d.total_allocated_amount)).join(' · '); });
      $$('[data-checkout]').forEach(b => b.disabled = busy || uncertain || !cart.item_count);
    };
    const readCart = async () => { const cart = await fetchJSON('/cart.js'); renderCart(cart); return cart; };
    const showCart = async () => {
      const dialog = $('.sf-cart-dialog'); if (dialog) openDialog(dialog);
      if (busy || uncertain) return;
      tell($('[data-cart-status]'), 'Loading your bag…'); setBusy(true);
      try { await readCart(); tell($('[data-cart-status]'), ''); }
      catch (error) { tell($('[data-cart-status]'), error.message); }
      finally { setBusy(false); }
    };
    $$('[data-open-cart]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); showCart(); }));
    root.addEventListener('click', async e => {
      const b = e.target.closest('[data-cart-quantity], [data-cart-remove]');
      if (!b || busy || uncertain) return;
      const key = b.dataset.key || b.dataset.cartRemove;
      const item = latestCart?.items.find(i => i.key === key); if (!item) return;
      const quantity = b.hasAttribute('data-cart-remove') ? 0 : item.quantity + Number(b.dataset.cartQuantity);
      setBusy(true); tell($('[data-cart-status]'), 'Updating your bag…');
      try { renderCart(await fetchJSON('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:key,quantity}) })); tell($('[data-cart-status]'), ''); }
      catch (error) {
        try { await readCart(); tell($('[data-cart-status]'), error.message + ' Your bag has been refreshed.'); }
        catch { uncertain = true; tell($('[data-cart-status]'), 'Unable to verify your bag. Refresh this page before making another change.'); }
      } finally { setBusy(false); }
    });
    form?.addEventListener('submit', async e => {
      e.preventDefault(); if (busy || uncertain || !purchasable || !selected?.available) return;
      const requestedId = selected.id;
      const data = new FormData(form); data.delete('return_to');
      setBusy(true); tell($('[data-form-error]'), '');
      let added = false;
      try {
        await fetchJSON('/cart/add.js', { method:'POST', body:data }); added = true;
        const cart = await readCart();
        if (!cart.items.some(i => String(i.variant_id) === String(requestedId) && i.properties?._enova_campaign === handle && i.quantity > 0)) throw new Error('Shopify did not confirm the selected item.');
        tell($('[data-cart-status]'), ''); openDialog($('.sf-cart-dialog'));
      } catch (error) {
        // A failed response can follow a successful write: never blindly retry an add.
        try { await readCart(); } catch { uncertain = true; }
        if (added || !error.status) uncertain = true;
        tell($('[data-form-error]'), error.message + (uncertain ? ' Check your bag and refresh before adding again.' : ' Nothing was confirmed added.'));
      } finally { setBusy(false); }
    });
    $$('[data-native-checkout-form]').forEach(f => f.addEventListener('submit', async e => {
      if (!e.submitter?.matches('[data-checkout]')) return;
      e.preventDefault(); if (busy || uncertain) return; setBusy(true);
      try { const cart = await readCart(); if (!cart.item_count) throw new Error('Your bag is empty.');
        // Native POST /cart with checkout=Checkout. This does not add the product again.
        const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = 'Checkout'; f.append(input);
        HTMLFormElement.prototype.submit.call(f);
      } catch (error) { tell($('[data-cart-status]'), error.message); setBusy(false); }
    }));
    const sticky = $('[data-sticky]');
    if (sticky && form) new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold:0 }).observe(form);
    if (root.matches('[data-cart-page]')) { showCart(); } else fetchJSON('/cart.js').then(cart => { if (busy || latestCart) return; latestCart = cart; $$('[data-cart-count]').forEach(n => n.textContent = String(cart.item_count)); }).catch(() => {});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
})();
